import { styled } from '@mui/material/styles';
import { Box, Stack } from '@mui/material';
import { AlumniSansFont } from '../../../styles/fonts';

export const StyledDropDownMenu = styled(Stack)(({ theme }) => ({
  position: 'absolute',
  top: '100%',
  left: '0%',
  width: '100%',

  alignItems: 'center',
  background: 'white',
  padding: '24px 0px',
  zIndex: 10000,
  boxShadow: `0px 2px 2px ${theme.palette.grey[100]}`,
}));

export const StyledDropDownMenuItems = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '101px',
  position: 'relative',
  //left: '10px',
}));

export const StyledDropDownMenuItem = styled(Box)(({ theme }) => ({
  paddingLeft: '18px',
  borderLeft: '0.6px solid #D7D7D7',
}));

export const StyledDropDownMenuItemContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
}));

export const Title = styled(Box)(({ theme }) => ({
  fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
  fontSize: '20px',
  lineHeight: '24px',
  fontWeight: 500,
  color: '#191A1B',
  letterSpacing: '0px',
}));

export const SubTitle = styled(Box)(({ theme }) => ({
  fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
  fontSize: '20px',
  lineHeight: '24px',
  fontWeight: 400,
  color: '#191A1B',
  letterSpacing: '0px',
  cursor: 'pointer',
}));

export const Item = styled(Box)(({ theme }) => ({
  fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 400,
  color: '#191A1B',
  letterSpacing: '0px',
  cursor: 'pointer',
}));

export const TitleItem = styled(Box)(({ theme }) => ({
  width: 'fit-content',
  fontFamily: `${AlumniSansFont.style.fontFamily}, sans-serif`,
  fontSize: '18px',
  lineHeight: '22px',
  fontWeight: 400,
  color: '#191A1B',
  letterSpacing: '0px',
  cursor: 'pointer',
}));
